import { render } from "./FooterKiosk.vue?vue&type=template&id=34580038"
import script from "./FooterKiosk.vue?vue&type=script&lang=js"
export * from "./FooterKiosk.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__